import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ScenarioDescription, ScenarioParameters, Vehicle } from '../../shared/DataTypes';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  http = inject(HttpClient);

  getScenarioParameters(vehicleId: number, scenarioName: string): Observable<ScenarioParameters> {
    return this.http.get<ScenarioParameters>(
      `${environment.apiURL}/vehicles/${vehicleId}/scenario-parameters`,
      { params: { scenario: scenarioName } }
    );
  }

  getVehicleObjectFromWorkspaceVehicleData(vehicle: any): Vehicle {
    const newVehicle: Vehicle = {
      ...vehicle,
      scenarios: vehicle.scenarios.map((scenario: any) => ({
        name: scenario.name,
        description: this.getFormattedScenarioDescription(scenario.description),
        drivingActions: scenario.drivingActions ?? [],
        stopActions: scenario.stopActions ?? []
      }))
    };
    return newVehicle;
  }

  getFormattedScenarioDescription(data: string): ScenarioDescription {
    const lines = data
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);
    const description = lines[1];
    const wind = lines[2].split('-')[1].trim();
    const temperature = lines[3].split(' ')[0] + '°';
    const life = lines[4] || '';

    return {
      description,
      wind,
      temperature,
      life
    };
  }
}
